export default {
  label: {
    filterTitle: 'Tag tree filter',
  },
};
